import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import Logo from "@/components/Logo";

export const COMPANY_ADDRESS = "8 Albert Ogbodu Close, Lagos, Nigeria";

const FooterLink = ({ to, children, testId }) => (
  <Link to={to} className="hover:text-terracotta transition-colors" data-testid={testId}>{children}</Link>
);

export default function SiteFooter({ tagline = "Discover. Watch. Support.", showNav = true, maxWidth = "max-w-[1600px]" }) {
  return (
    <footer className="px-6 sm:px-12 lg:px-20 py-12 border-t border-white/5" data-testid="site-footer">
      <div className={`${maxWidth} mx-auto flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6`}>
        <div className="flex items-center gap-3">
          <Logo size={36} />
          <div className="text-xs text-foreground/50 space-y-0.5">
            <p>© {new Date().getFullYear()} Cinevoya</p>
            <p>{tagline}</p>
            <p className="flex items-center gap-1" data-testid="footer-address">
              <MapPin className="w-3 h-3 text-terracotta" /> {COMPANY_ADDRESS}
            </p>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-foreground/60">
          {showNav && <FooterLink to="/about" testId="footer-about-link">Our story</FooterLink>}
          {showNav && <FooterLink to="/browse" testId="footer-browse-link">Browse</FooterLink>}
          <FooterLink to="/terms" testId="footer-terms-link">Terms &amp; Conditions</FooterLink>
          <FooterLink to="/privacy-policy" testId="footer-privacy-link">Privacy Policy</FooterLink>
          <FooterLink to="/refund-policy" testId="footer-refund-link">Refund Policy</FooterLink>
          <span className="text-terracotta">Made for storytellers.</span>
        </div>
      </div>
    </footer>
  );
}
